import RichText from 'molecules/RichText';
import TwoColumnGrid from 'molecules/TwoColumnGrid';
import WistiaVideoPlayer from 'molecules/Video';

import type { VideoComponentProps } from 'components/Video/config';
import type { FeaturedTextStatsProps } from 'molecules/Stats';
import type { ComponentPropsWithoutRef, FC } from 'react';

type ComponentVideoProps = VideoComponentProps &
  Pick<FeaturedTextStatsProps, 'featuredStats'> &
  ComponentPropsWithoutRef<'section'>;

const ComponentVideo: FC<ComponentVideoProps> = ({ embed, body }) => (
  <TwoColumnGrid width="wide">
    {embed && <WistiaVideoPlayer embed={embed} />}
    {body && <RichText content={body} />}
  </TwoColumnGrid>
);

export default ComponentVideo;
